import { Skeleton } from '@avanta/shared/components/ui/Skeleton';

const SKELETON_COUNT = 7;

export const PatientCardSkeleton = (): React.ReactElement => (
  <>
    {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
      <div
        key={index}
        className="flex w-full items-center gap-4 overflow-hidden rounded-xl border border-teal-300 bg-white py-4 pr-4 pl-6"
      >
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton className="h-5 w-48" />
          <div className="flex items-start gap-4">
            <div className="flex min-w-0 flex-1 flex-col gap-3">
              <Skeleton className="h-4.5 w-40" />
              <Skeleton className="h-4.5 w-28" />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <Skeleton className="h-4.5 w-36" />
            </div>
          </div>
        </div>
        <Skeleton className="size-8 shrink-0 rounded-md" />
      </div>
    ))}
  </>
);
